module.exports = __webpack_public_path__ + "img/H000110_fishred.b99aad87.png";